import React, { useState } from 'react';
import { styled } from '@mui/system';
import { Typography, TextField, Button, Alert } from '@mui/material';
import { SaveSessionCookie } from '../../logic/CookieManager';
import * as MyStyles from '../../styles/MyStyles';
import { useNavigate } from 'react-router-dom';

const LoginContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 300px;
  max-width: 300px;
  margin: 16px auto 0;
`;

const LoginButton = styled(Button)`
  background-color: ${MyStyles.Orange};
  color: #fff;

  &:hover {
    background-color: ${MyStyles.Orange};
  }
`;

const RegistrationPage = (props) => {
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState(false);
    const navigate = useNavigate();
    const {setIsLoggedIn, setIsLoading } = props;

    const [stage, setStage] = useState(0);

    const handleNext = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_REGISTRATION_STAGE1_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email }),
            });

            if (response.ok) {
                setLoginError(false);
                setStage(1);
            } else {
                setLoginError(true);
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleRegister = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_REGISTRATION_STAGE2_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    password: password,
                    otp: otp
                }),
            });

            if (response.ok) {
                const data = await response.json();
                const token = data.data.token;
                SaveSessionCookie('nplt', token);
                setIsLoading(true);
                setIsLoggedIn(true);

                navigate('/');
            } else {
                setIsLoggedIn(false);
                setLoginError(true);
                console.log('Login failed');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    return (
        <LoginContainer>
            <Typography variant="h6" component="div">
                Registration Form
            </Typography>
            <TextField
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            {stage === 0 && (
                <LoginButton variant="contained" color="primary" onClick={handleNext}>
                    Next
                </LoginButton>
            )}

            {stage === 1 && (
                <>
                    <TextField
                        label="Password"
                        type="password"
                        variant="outlined"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <TextField
                        label="One-time password from email"
                        variant="outlined"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                    />
                    <LoginButton variant="contained" color="primary" onClick={handleRegister}>
                        Register
                    </LoginButton>
                </>
            )}
            {loginError && (
                <Alert severity="error">Registration failed. Please check your credentials.</Alert>
            )}
        </LoginContainer>
    );
};

export default RegistrationPage;
